/*!
 * KoliBri - The accessible HTML-Standard
 */
import { c as createPropDefinition, a as normalizeInteger } from './normalizers-BNeak4hj.js';

const headingLevelOptions = [0, 1, 2, 3, 4, 5, 6];
const levelProp = createPropDefinition('level', 0, (value) => normalizeInteger(value), (v) => headingLevelOptions.includes(v));

export { headingLevelOptions as h, levelProp as l };
//# sourceMappingURL=level-Cj2m5HKt.js.map

//# sourceMappingURL=level-Cj2m5HKt.js.map